import { Permission, type SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';

/**
 * Schlanker Skill-Descriptor — wird vom Bootstrap importiert, OHNE den Barrel
 * (MailInboxPage, MailAccountSettings) eager zu laden. Die Inbox-Seite kommt
 * über die Lazy-Route in App.tsx.
 */
const manifest: SkillManifest = {
  key: 'mail-inbound',
  name: 'Mail-Inbox',
  description:
    'Eingehende Mails per IMAP polling, KI-basierter Projekt-Vorschlag, ' +
    'Übernahme als Projekt-Input.',
  category: 'data',
  version: '0.1.0',
  requiredPermissions: [Permission.MAIL_INBOX_READ],
  enabledByDefault: true,
};

export const mailInboundSkill: FrontendSkill = {
  manifest,
  slots: {},
};
